import { Button, Divider } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { Spacer } from '../../components/Spacer/Spacer';

export const EditorPage: React.FC<void> = () => {
  const tools: {
    title: string;
    description: string;
    action: string;
    link: string;
  }[] = [
    {
      title: 'Mapper-Fehler-Check',
      description: 'Eine Liste von Nutzern wird überprüft.',
      action: 'Zur Überprüfung',
      link: '/mapper',
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h1>Statisiken</h1>
      <div>
        Hier gibt es verschiedene Tools zur statistischen Auswertung unserer
        Daten. Einige Tools sind relativ teuer, weswegen man sie mit bedacht
        benutzen sollte.
      </div>
      <Spacer />
      <Divider />

      <div style={{ display: 'flex', marginTop: 20 }}>
        {tools.map(({ title, description, action, link }) => (
          <div
            key={title}
            style={{
              border: '1px solid lightgray',
              borderRadius: 6,
              width: 300,
              padding: 10,
              margin: 5,
            }}>
            <h2 style={{ marginTop: 10 }}>{title}</h2>
            <div>{description}</div>
            <Spacer />
            <Link to={link}>
              <Button>{action}</Button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
